@import '../../styles/customMediaQueries.css';

.root {
  @apply __marketplaceModalFormRootStyles;

  justify-content: flex-start;

  @media (--viewportMedium) {
    justify-content: space-between;
  }
}

.name {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.firstNameRoot {
  width: calc(34% - 9px);
}

.lastNameRoot {
  width: calc(66% - 9px);
}

.password {
  @apply __marketplaceModalPasswordMargins;
}

.bottomWrapper {
  @apply __marketplaceModalBottomWrapper;
}

.bottomWrapperText {
  @apply __marketplaceModalBottomWrapperText;
}

.termsText {
  @apply __marketplaceModalHelperText;
}

.termsLink {
  @apply __marketplaceModalHelperLink;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
